import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import Tool, { type ToolArgs } from '../../../tools/Tool';
import { isMediaElement } from '../../../types/guards';
import MediaCommon from '../MediaCommon';
import lineWeightSvg from '../../../assets/icons/lineWeight.svg';
import { type MediaElement } from '../../../types/aha-editor';
import ToolBorderWidthSlider from './ToolBorderWidthSlider';

class ToolBorderWidth extends Tool {
  static toolName = '';
  static iconSvg = lineWeightSvg;

  static action(args: ToolArgs & { width?: number }): void {
    const { editor, element, width = 0 } = args;

    if (!element || !isMediaElement(element)) return;

    const path = ReactEditor.findPath(editor, element);

    // If setting a border width and no border color is set, set default color
    const updates: Partial<MediaElement> = { media_borderWidth: width };
    if (width > 0 && !element.media_borderColor) {
      updates.media_borderColor = MediaCommon.defaultBorderColor;
    }

    Transforms.setNodes(editor, updates, { at: path });
  }

  static submenuTools = () => [[ToolBorderWidthSlider]];
  static submenuType = 'icons' as const;
}

export default ToolBorderWidth;
